import React from "react";
import { Button } from "@chakra-ui/react";

interface CompareButtonProps {
  onClick?: () => void;
}

const CompareButton: React.FC<CompareButtonProps> = ({ onClick }) => {
  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <Button
      position="absolute"
      bottom="19px"
      right="5"
      size="xs"
      bg="purple.400"
      color="white"
      fontWeight="semibold"
      onClick={handleClick}
      _hover={{ bg: "purple.500" }}
      fontSize="xs"
      h="24px"
      px="2"
      zIndex={2}
    >
      Compare
    </Button>
  );
};

export default CompareButton; 